//# sourceMappingURL=llm_capacity.mjs.map
/// <reference types="./llm_capacity.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $timestamp_ from "../../tiamat/gleam/time/timestamp_.mjs";
import * as $decrypt from "../decrypt.mjs";
import { Ok, Error, toList, CustomType as $CustomType } from "../gleam.mjs";

export class RateLimits extends $CustomType {
  constructor(rpm, tpm, itpm, otpm) {
    super();
    this.rpm = rpm;
    this.tpm = tpm;
    this.itpm = itpm;
    this.otpm = otpm;
  }
}
export const RateLimits$RateLimits = (rpm, tpm, itpm, otpm) =>
  new RateLimits(rpm, tpm, itpm, otpm);
export const RateLimits$isRateLimits = (value) => value instanceof RateLimits;
export const RateLimits$RateLimits$rpm = (value) => value.rpm;
export const RateLimits$RateLimits$0 = (value) => value.rpm;
export const RateLimits$RateLimits$tpm = (value) => value.tpm;
export const RateLimits$RateLimits$1 = (value) => value.tpm;
export const RateLimits$RateLimits$itpm = (value) => value.itpm;
export const RateLimits$RateLimits$2 = (value) => value.itpm;
export const RateLimits$RateLimits$otpm = (value) => value.otpm;
export const RateLimits$RateLimits$3 = (value) => value.otpm;

/**
 * The provider sent its rate-limit headers: `limits` holds them.
 */
export class Read extends $CustomType {}
export const ProviderLimitsStatus$Read = () => new Read();
export const ProviderLimitsStatus$isRead = (value) => value instanceof Read;

/**
 * The provider never sends rate-limit headers (Bedrock, Gemini).
 */
export class NotSent extends $CustomType {}
export const ProviderLimitsStatus$NotSent = () => new NotSent();
export const ProviderLimitsStatus$isNotSent = (value) =>
  value instanceof NotSent;

/**
 * The ping itself failed; the deployment may be broken.
 */
export class CallFailed extends $CustomType {
  constructor(error) {
    super();
    this.error = error;
  }
}
export const ProviderLimitsStatus$CallFailed = (error) => new CallFailed(error);
export const ProviderLimitsStatus$isCallFailed = (value) =>
  value instanceof CallFailed;
export const ProviderLimitsStatus$CallFailed$error = (value) => value.error;
export const ProviderLimitsStatus$CallFailed$0 = (value) => value.error;

export class LlmRateLimit extends $CustomType {
  constructor(deployment_id, model_alias, status, limits, refreshed_at) {
    super();
    this.deployment_id = deployment_id;
    this.model_alias = model_alias;
    this.status = status;
    this.limits = limits;
    this.refreshed_at = refreshed_at;
  }
}
export const LlmRateLimit$LlmRateLimit = (deployment_id, model_alias, status, limits, refreshed_at) =>
  new LlmRateLimit(deployment_id, model_alias, status, limits, refreshed_at);
export const LlmRateLimit$isLlmRateLimit = (value) =>
  value instanceof LlmRateLimit;
export const LlmRateLimit$LlmRateLimit$deployment_id = (value) =>
  value.deployment_id;
export const LlmRateLimit$LlmRateLimit$0 = (value) => value.deployment_id;
export const LlmRateLimit$LlmRateLimit$model_alias = (value) =>
  value.model_alias;
export const LlmRateLimit$LlmRateLimit$1 = (value) => value.model_alias;
export const LlmRateLimit$LlmRateLimit$status = (value) => value.status;
export const LlmRateLimit$LlmRateLimit$2 = (value) => value.status;
export const LlmRateLimit$LlmRateLimit$limits = (value) => value.limits;
export const LlmRateLimit$LlmRateLimit$3 = (value) => value.limits;
export const LlmRateLimit$LlmRateLimit$refreshed_at = (value) =>
  value.refreshed_at;
export const LlmRateLimit$LlmRateLimit$4 = (value) => value.refreshed_at;

export class OrgActivity extends $CustomType {
  constructor(org_id, projects, proposals, questions) {
    super();
    this.org_id = org_id;
    this.projects = projects;
    this.proposals = proposals;
    this.questions = questions;
  }
}
export const OrgActivity$OrgActivity = (org_id, projects, proposals, questions) =>
  new OrgActivity(org_id, projects, proposals, questions);
export const OrgActivity$isOrgActivity = (value) =>
  value instanceof OrgActivity;
export const OrgActivity$OrgActivity$org_id = (value) => value.org_id;
export const OrgActivity$OrgActivity$0 = (value) => value.org_id;
export const OrgActivity$OrgActivity$projects = (value) => value.projects;
export const OrgActivity$OrgActivity$1 = (value) => value.projects;
export const OrgActivity$OrgActivity$proposals = (value) => value.proposals;
export const OrgActivity$OrgActivity$2 = (value) => value.proposals;
export const OrgActivity$OrgActivity$questions = (value) => value.questions;
export const OrgActivity$OrgActivity$3 = (value) => value.questions;

function limits_decoder() {
  return $decrypt.optional_field(
    "rpm",
    $decrypt.int(),
    (rpm) => {
      return $decrypt.optional_field(
        "tpm",
        $decrypt.int(),
        (tpm) => {
          return $decrypt.optional_field(
            "itpm",
            $decrypt.int(),
            (itpm) => {
              return $decrypt.optional_field(
                "otpm",
                $decrypt.int(),
                (otpm) => {
                  return $decode.success(new RateLimits(rpm, tpm, itpm, otpm));
                },
              );
            },
          );
        },
      );
    },
  );
}

function metadata_decoder() {
  return $decrypt.optional_field(
    "status",
    $decode.string,
    (status) => {
      return $decrypt.optional_field(
        "error",
        $decode.string,
        (error) => {
          return $decrypt.optional_field(
            "limits",
            limits_decoder(),
            (limits) => {
              let _block;
              if (status instanceof Some) {
                let $ = status[0];
                if ($ === "ok") {
                  _block = new Read();
                } else if ($ === "no_headers") {
                  _block = new NotSent();
                } else if (error instanceof Some) {
                  let error$1 = error[0];
                  _block = new CallFailed(error$1);
                } else {
                  _block = new CallFailed("No status recorded");
                }
              } else if (error instanceof Some) {
                let error$1 = error[0];
                _block = new CallFailed(error$1);
              } else {
                _block = new CallFailed("No status recorded");
              }
              let status$1 = _block;
              let limits$1 = $option.unwrap(
                limits,
                new RateLimits(new None(), new None(), new None(), new None()),
              );
              return $decode.success([status$1, limits$1]);
            },
          );
        },
      );
    },
  );
}

export function rate_limit_decoder() {
  return $decode.field(
    "deployment_id",
    $decode.string,
    (deployment_id) => {
      return $decode.field(
        "model_alias",
        $decode.string,
        (model_alias) => {
          return $decode.field(
            "metadata",
            $decrypt.json(metadata_decoder()),
            (_use0) => {
              let status = _use0[0];
              let limits = _use0[1];
              return $decode.field(
                "refreshed_at",
                $decrypt.timestamp(),
                (refreshed_at) => {
                  return $decode.success(
                    new LlmRateLimit(
                      deployment_id,
                      model_alias,
                      status,
                      limits,
                      refreshed_at,
                    ),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function encode_metadata(status, limits) {
  let _block;
  if (status instanceof Read) {
    _block = toList([["status", $json.string("ok")]]);
  } else if (status instanceof NotSent) {
    _block = toList([["status", $json.string("no_headers")]]);
  } else {
    let error = status.error;
    _block = toList([
      ["status", $json.string("error")],
      ["error", $json.string(error)],
    ]);
  }
  let status_fields = _block;
  let _block$1;
  let _pipe = toList([
    ["rpm", limits.rpm],
    ["tpm", limits.tpm],
    ["itpm", limits.itpm],
    ["otpm", limits.otpm],
  ]);
  _block$1 = $list.filter_map(
    _pipe,
    (limit) => {
      let $ = limit[1];
      if ($ instanceof Some) {
        let name = limit[0];
        let value = $[0];
        return new Ok([name, $json.int(value)]);
      } else {
        return new Error(undefined);
      }
    },
  );
  let limit_fields = _block$1;
  return $json.object(
    $list.append(
      status_fields,
      toList([["limits", $json.object(limit_fields)]]),
    ),
  );
}

export function encode_rate_limit(rate_limit) {
  return $json.object(
    toList([
      ["deployment_id", $json.string(rate_limit.deployment_id)],
      ["model_alias", $json.string(rate_limit.model_alias)],
      ["metadata", encode_metadata(rate_limit.status, rate_limit.limits)],
      ["refreshed_at", $timestamp_.encode(rate_limit.refreshed_at)],
    ]),
  );
}

export function org_activity_decoder() {
  return $decode.field(
    "org_id",
    $decode.string,
    (org_id) => {
      return $decode.field(
        "projects",
        $decrypt.int(),
        (projects) => {
          return $decode.field(
            "proposals",
            $decrypt.int(),
            (proposals) => {
              return $decode.field(
                "questions",
                $decrypt.int(),
                (questions) => {
                  return $decode.success(
                    new OrgActivity(org_id, projects, proposals, questions),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_org_activity(activity) {
  return $json.object(
    toList([
      ["org_id", $json.string(activity.org_id)],
      ["projects", $json.int(activity.projects)],
      ["proposals", $json.int(activity.proposals)],
      ["questions", $json.int(activity.questions)],
    ]),
  );
}
